import httpService from '@/helper/httpService';

const EmptyPdf = "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/Ohne.pdf";

const maklerService = {
  title: "Maklerservice",
  type: "Makler",
  phone: "(+49) 02 21 / 37 638 - 92",
  phoneClickable: '+492213763892',
  fax: "(+49) 02 21 / 37 638 - 73 92",
  email: "maklerservice@dmb-rechtsschutz.de",
  time: "Montag - Freitag 8:00 - 18:00 Uhr"
};

const rechtService = {
  title: "DMB RECHT-Hotline",
  type: "DMB RECHT",
  subtitle: "Bei Rechtsfragen Ihrer Kunden",
  phone: "(+49) 08 00 / 36 27 32 48*",
  phoneClickable: '+4980036273248',
  time: "Montag - Freitag 8:00 - 20:00 Uhr",
  footnote: "deutschlandweit gebührenfrei"
};

const state = {
  StartseiteNews: null,
  StartseiteAuszeichnungen: null,
  ProduktePrivat: null,
  ProduktePrivatWeitere: null,
  ProdukteGewerbe: null,
  ProdukteKomedex: null,
  ProdukteAgromex: null,
  ProdukteService: null,
  VertriebRechtAktuell: null,
  VertriebSEPA: null,
  VertriebVerkaufshilfen: null,
  VertriebMaklerservice: {
    service: {
      sectionTitle: 'Service für Makler',
      persons: [
        {
          name: 'Viktoria Jiménez García',
          rolle: 'Leiterin\nPartner- & Kundenservice\nKey Account & Vertriebsunterstützung\n',
          phone: '(+49) 02 21 / 37 638 - 21',
          phoneClickable: '+492213763821',
          fax: '',
          email: '',
          imgSrc: '/Jimenez2022.jpg',
        },
        {
          name: 'Nadine Biermann',
          rolle: 'Maklerservice & Key Account\nLandwirtschafts-Rechtsschutz',
          phone: '(+49) 02 21 / 37 638 - 12',
          phoneClickable: '+492213763812',
          fax: '',
          email: '',
          imgSrc: '/Biermann2019.jpg',
        },
        {
          name: 'Ronald Doll',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 14',
          phoneClickable: '+492213763814',
          fax: '',
          email: '',
          imgSrc: '/Doll2020.jpg',
        },
        {
          name: 'Dusica Kähler',
          rolle: 'Maklerservice & Key Account\nÄrzte/Heilberufe',
          phone: '(+49) 02 21 / 37 638 - 71',
          phoneClickable: '+492213763871',
          fax: '',
          email: '',
          imgSrc: '/Kaehler2019.jpg',
        },
        {
          name: 'Susann Klimpel-Hildebrandt',
          rolle: 'Maklerservice &\nGewerbetreibende/&#8203;Selbstständige',
          phone: '(+49) 02 21 / 37 638 - 57',
          phoneClickable: '+492213763844',
          fax: '',
          email: '',
          imgSrc: '/Klimpel-Hildebrandt2019.jpg',
        },
        {
          name: 'Julia Köhler',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 29',
          phoneClickable: '+492213763829',
          fax: '',
          email: '',
          imgSrc: '/Koehler2020.jpg',
        },
        {
          name: 'Jürgen Kretschmer',
          rolle: 'Maklerservice & Key Account',
          phone: '(+49) 02 21 / 37 638 - 59',
          phoneClickable: '+492213763859',
          fax: '',
          email: '',
          imgSrc: '/Kretschmer2022.jpg',
        },
        {
          name: 'Markus Lauffs',
          rolle: 'Maklerservice &\nVereins-Rechtsschutz',
          phone: '(+49) 02 21 / 37 638 - 39',
          phoneClickable: '+492213763839',
          fax: '',
          email: '',
          imgSrc: '/Lauffs2019.jpg',
        },
        {
          name: 'Michael Streckert',
          rolle: 'Maklerservice &\nCourtagen/Provisionen',
          phone: '(+49) 02 21 / 37 638 - 28',
          phoneClickable: '+492213763828',
          fax: '',
          email: '',
          imgSrc: '/Streckert2019.jpg',
        },
        {
          name: 'Piotr Tobola',
          rolle: 'Maklerservice &\nCourtagen/Provisionen\nVergleichsrechner/&#8203;Internetportale',
          phone: '(+49) 02 21 / 37 638 - 43',
          phoneClickable: '+492213763843',
          fax: '',
          email: '',
          imgSrc: '/Tobola2019.jpg',
        },
        {
          name: 'Thilo Zwingelberg',
          rolle: 'Maklerservice ',
          phone: '(+49) 02 21 / 37 638 - 44',
          phoneClickable: '+492213763844',
          fax: '',
          email: '',
          imgSrc: '/Zwingelberg2022.jpg',
        }
      ]
    },
    vorOrt: {
      sectionTitle: 'Maklerbetreuung vor Ort',
      persons: [
        {
          name: 'Antje Arlautzki',
          rolle: 'Vertriebsleiterin Ost',
          phone: '0160 / 99 79 63 55',
          phoneClickable: '+4916099796355',
          email: 'antje.arlautzki@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/antje-arlautzki-dmb-rechtsschutz',
          imgSrc: '/Arlautzki2019.jpg',
          cssClass: 'profile--img',
        },
        {
          name: 'Peter Hofmann',
          rolle: 'Vertriebsleiter West',
          phone: '0173 / 40 38 540',
          phoneClickable: '+491734038540',
          email: 'peter.hofmann@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/peter-hofmann-dmb-rechtsschutz',
          imgSrc: '/Hofmann2019.jpg',
          cssClass: 'profile--img',
        },
        {
          name: 'Florian Rockenfeld',
          rolle: 'Vertriebsleiter Süd',
          phone: '0171 / 77 71 144',
          phoneClickable: '+4901717771144',
          email: 'florian.rockenfeld@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/florian-rockenfeld-dmb-rechtsschutz',
          imgSrc: '/Rockenfeld2021.jpg',
          cssClass: 'profile--img',
        },
//        {
//          name: '',
//          rolle: '',
//          phone: '',
//          phoneClickable: '',
//          email: '',
//          termin: '',
//          imgSrc: '',
//          cssClass: 'profile--img',
//        },
        {
          name: 'Candy Huster',
          rolle: 'Digital Manager Vertrieb',
          phone: '0221 / 37 638 7514',
          phoneClickable: '+0221376387514',
          email: 'candy.huster@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/candy-huster-dmb-rechtsschutz',
          imgSrc: '/Huster2022.jpg',
          cssClass: 'profile--img',
        },
        {
          name: 'Milan Jarosch',
          rolle: 'Leiter Vertrieb',
          phone: '0171 / 77 76 62 6',
          phoneClickable: '+4901717776626',
          email: 'milan.jarosch@dmb-rechtsschutz.de',
          imgSrc: '/Jarosch2021.jpg',
          cssClass: 'profile--img',
        }
      ],
    }
  },
  VertriebMaklerServiceSidebar: [
    maklerService,
    {
      title: "Anträge einreichen",
      type: "Antrag",
      phone: "",
      fax: "(+49) 02 21 / 37 638 - 73 14",
      email: "antrag@dmb-rechtsschutz.de"
    },
    rechtService,
    {
      title: "Fragen zu Schäden",
      type: "Schaden",
      phone: "(+49) 02 21 / 37 638 - 93",
      phoneClickable: '+492213763893',
      fax: "",
      email: "schaden@dmb-rechtsschutz.de"
    }
  ],
  AboutUnternehmen: null,
  AboutUnternehmenMaklerBox: maklerService,
  AboutPresse: null,
  AboutAuszeichnungen: null,
  ARB: null,
  ARB_SUS: null,
  ARB_YOLIG: null,
  PI_Standard: null,
  PI_EXPERT: null,
  PI_PRESTIGE: null,
  PI_SUS: null,
  PI_YOLIG: null,
  HL_Standard: null,
  HL_EXPERT: null,
  HL_PRESTIGE: null,
  HL_SUS: null,
  HL_YOLIG: null,
  nachweis_vorversicherer: null,
  EmptyPdf: EmptyPdf
};

const actions = {
  populateContent({ commit, state, getters }, paths) {
    let requests = [];
    paths.map(path => {
      if (state[path] === null) {
        requests.push(httpService.getStaticContent(path)
          .then(result => commit("updateStaticContent", {
            path,
            newContent: result,
            isCharta: getters.isChartaUser,
            isPool: getters.isPoolUser
          })));
      }
    });
    return Promise.all(requests);
  },
};

const mutations = {
  updateStaticContent(state, { path, newContent, isCharta, isPool }) {
    if (path === "AboutUnternehmen") {
      state.AboutUnternehmen = convertAboutUnternehmen(newContent);
    } else if (path.startsWith("Produkte") || path.startsWith("HL_")) {
      state[path] = filterUserContent(newContent, [
          { key: "charta_", value: isCharta },
          { key: "s1", value: isPool }
        ]);
    } else {
      state[path] = newContent;
    }
  },
  resetStaticUserContent(state) {
    Object.keys(state).forEach(key => {
      if (key.startsWith("Produkte") || key.startsWith("HL_")) {
        state[key] = null;
      }
    });
  }
};

function convertAboutUnternehmen(backendContent) {
  const downloadsBoxInfo = backendContent.downloadsBox;
  return {
    content: backendContent.content,
    downloadsBox: {
      title: downloadsBoxInfo.sectionTitle,
      type: "link",
      links: downloadsBoxInfo.items
    }
  };
}

function filterUserContent(backendContent, filters) {
  function _filterContent(content, key, value) {
    let _content = Object.assign({}, content);
    if (!value) {
      _content.items = content.items.filter(i => !i.link.toLowerCase().includes(key));
    } else {
      content.items
        .filter(i => i.link.toLowerCase().includes(key))
        .map(i => {
          return {
            link: i.link,
            split: i.link.toLowerCase().split(key).map(s => s.toLowerCase())
          };
        })
        .forEach(i => {
          _content.items = _content.items.filter(j =>
            !(j.link.toLowerCase().startsWith(i.split[0].substr(0, i.split[0].length - 1)) &&
            j.link.toLowerCase().endsWith(i.split[1].substr(1))) || j.link === i.link
          );
        });
    }
    return _content;
  }
  let filteredContent = backendContent;
  if (Array.isArray(backendContent.sections)) {
    filters.forEach(filter => {
      filteredContent = {
        sections: filteredContent.sections.map(c => _filterContent(c, filter.key, filter.value))
      };
    });
  } else if (backendContent.items && Array.isArray(backendContent.items)) {
    filters.forEach(filter => {
      filteredContent = _filterContent(filteredContent, filter.key, filter.value);
    });
  }
  return filteredContent;
}

export default {
  state,
  actions,
  mutations
};
